/* ============================================================
   KP META PIXEL — assets/kp-meta-pixel.js, loaded with defer alongside
   kp-remarketing.js. The browser half of the Meta stack; the server half
   (Conversions API Purchase from the order webhook) is in the Worker.

   WHY THIS FILE EXISTS (6 Aug 2026). Simprosys' pixel was the only thing on
   the site loading Meta's fbevents.js, and that script is the ONLY thing that
   creates the _fbp cookie — Shopify does not set it and a server cannot (it is
   a browser cookie). With Simprosys disabled, new visitors get no _fbp, the
   cart-attribute capture in kp-analytics-beacon.js has nothing to forward, and
   CAPI match quality decays as old cookies expire. Meta also stops receiving
   ViewContent/AddToCart entirely, so remarketing audiences ("viewed but did
   not buy") stop refilling.

   Same protection model as kp-remarketing.js:
     - nothing loads until a TRUSTED interaction (isTrusted), so crawlers and
       scrapers never run fbevents.js, never get an _fbp, never enter audiences
     - consent from Shopify's Customer Privacy API when present

   The pixel id is necessarily visible here — a browser tag cannot hide it, and
   it was already public for years via Simprosys. Traffic permissions in Events
   Manager are the containment for id abuse.

   Purchase is deliberately NOT sent from the browser: theme scripts do not run
   on the thank-you page, and the webhook CAPI Purchase (verified against the
   Shopify Admin API) already covers every sale. eventID on AddToCart uses the
   cart token so a future CAPI AddToCart could deduplicate against it.
   ============================================================ */
(function () {
  var PIXEL_ID = '408079079819236';
  var storeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function measurementAllowed() {
    return !window.kpTrackingPolicy || window.kpTrackingPolicy.allowed();
  }

  function marketingAllowed() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.marketingAllowed === 'function') return cp.marketingAllowed();
    } catch (e) {}
    return true; /* no consent platform installed -> Shopify allows pixels */
  }

  function activeCurrency() {
    try { return String(window.Shopify.currency.active || 'GBP'); } catch (e) { return 'GBP'; }
  }

  function cookieValue(name) {
    try {
      var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]+)'));
      return m ? decodeURIComponent(m[1]) : '';
    } catch (e) { return ''; }
  }

  function syncMetaIdsToCart() {
    if (document.querySelector('[data-kp-finder-market-gate]')) return;
    var fbp = cookieValue('_fbp');
    var fbc = cookieValue('_fbc');
    if (!fbp && !fbc) return;
    var attrs = {};
    if (fbp) attrs._fbp = fbp;
    if (fbc) attrs._fbc = fbc;
    // Queued with the other page-load cart writers (kp-cart-attributes).
    if (window.kpCartAttributes) { window.kpCartAttributes(attrs); return; }
    fetch(storeRoot + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs }),
      keepalive: true
    }).then(function (r) {
      if (!r.ok) throw new Error('cart sync ' + r.status);
    }).catch(function () {});
  }

  window.addEventListener('pageshow', function(e) { if (e.persisted) syncMetaIdsToCart(); });

  var loaded = false;
  function ensureFbq() {
    if (loaded) return;
    if (!measurementAllowed()) return;
    loaded = true;
    /* Meta's standard bootstrap, unminified. */
    var n = window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = n;
    n.push = n; n.loaded = true; n.version = '2.0'; n.queue = [];
    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(s);
    /* ADVANCED MATCHING (7 Aug 2026). init() carried no user data, so every
       browser event — PageView, ViewContent, AddToCart — reached Meta with
       nothing but IP, user agent and fbp. Events Manager scored both
       ViewContent and AddToCart 6.1/10 with External ID at 0%, while Purchase
       (sent server-side from the order webhook, which does have customer data)
       scored far higher. This closes that gap.

       external_id is the right field to add here and the only one available:
       an anonymous browser has no email or phone, but it always has _kp_cid —
       the first-party id kp-analytics-beacon.js mints and persists for a year.
       Meta hashes external_id itself, so it is passed raw, and the SAME value
       is sent from the order webhook (see metaUserData) so a browser
       ViewContent and a server Purchase resolve to one person. Sending a
       different id on each side would score well and unify nothing. */
    var initData = {};
    try {
      var m = document.cookie.match(/(?:^|;\s*)_kp_cid=([^;]+)/);
      var cid = m ? decodeURIComponent(m[1]) : (localStorage.getItem('kp_cid') || '');
      if (cid) initData.external_id = cid;
    } catch (e) {}

    /* INP (17 Oct 2026). Meta's automatic configuration adds a document click
       listener that inspects every tapped button for "SubscribedButtonClick"
       events and scans the page for product microdata. On an Add to basket tap
       it took 74–98 ms at 4x CPU (tap 216 ms with tracking, 48 ms without).
       Every event Meta needs is sent explicitly below and from the Worker, so
       it is switched off. Must be set before init. */
    window.fbq('set', 'autoConfig', false, PIXEL_ID);
    if (initData.external_id) window.fbq('init', PIXEL_ID, initData);
    else window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
    setTimeout(syncMetaIdsToCart, 1500);
    setTimeout(syncMetaIdsToCart, 5000);
  }

  function fireForPage() {
    var b = document.body;
    if (!b) return;
    if (b.dataset.pageType === 'product' && b.dataset.productSku) {
      window.fbq('track', 'ViewContent', {
        content_ids: [b.dataset.productSku],
        content_type: 'product',
        value: parseFloat(b.dataset.productPrice || '0') || 0,
        currency: activeCurrency()
      });
    }
  }

  /* Cart adds refill the "added but did not buy" audience. SKU ids only —
     they are what the catalog is keyed on. */
  document.addEventListener('kp:analytics', function (e) {
    if (!loaded) return;
    var d = e && e.detail;
    if (!d || d.event !== 'cart_add_success' || !d.product_sku) return;
    window.fbq('track', 'AddToCart', {
      content_ids: [String(d.product_sku)],
      content_type: 'product',
      value: (parseFloat(d.product_price || '0') || 0) * Math.max(1, Number(d.quantity) || 1),
      currency: activeCurrency()
    }, { eventID: 'atc.' + (d.cart_token || Date.now()) });
  });

  /* INTERACTION ONLY — deliberately, and NOT the dwell gate used by
     kp-remarketing.js.

     Dwell was tried on 7 Aug 2026 and reverted the same day. The argument for
     it was that a reader who never scrolls gets no _fbp cookie, costing CAPI
     match quality. The argument against it is the numbers: Facebook sent 2,912
     sessions and ZERO checkouts in the preceding 30 days. Loading 110KB of
     fbevents.js (plus 12.5KB of Babel polyfills Meta still ships) on every page
     after 2.5s, to improve matching on conversions that are not happening, is
     the wrong trade — and it put fbevents into every Lighthouse run.

     If Meta ads start producing sales, switch this to the dwell gate in
     kp-remarketing.js and accept the weight. Until then it stays behind a real
     interaction: anyone who actually engages still gets an _fbp. */

  /* ── automation gate ──────────────────────────────────────
     Added 7 Aug 2026. The dwell gate below does NOT keep bots out: 614 bot
     events reached kp-analytics-beacon.js in three days, and the beacon uses
     the same 2.5s dwell — so every one of them sat on the page for longer than
     that. 263 were signals_swRender, i.e. headless browsers. Dwell only stops
     curl and python-requests.

     That mattered here more than anywhere else, because gtag talks DIRECTLY to
     Google. The Cloudflare Worker filters bots out of Measurement Protocol,
     but it never sees a gtag hit — so every one of those bots was creating a
     real GA4 session by a route nothing was guarding.

     Same signals kp-analytics-beacon.js already computes. Conservative: a false
     positive costs one session of tracking, a false negative costs the accuracy
     of the whole property. */
  function looksAutomated() {
    try {
      if (navigator.webdriver === true) return true;
      if (!screen.width || !screen.height) return true;
      if (!window.outerWidth) return true;
      if (!navigator.languages || !navigator.languages.length) return true;
      if (navigator.hardwareConcurrency === 0) return true;
      var ua = navigator.userAgent || '';
      if (/iPhone|iPad|Android|Mobile/i.test(ua) && !(navigator.maxTouchPoints > 0)) return true;
      /* Software WebGL renderer — the single strongest signal in our data. */
      // Reuse the document's renderer probe across tracking clients and inputs.
      if (window.KPBrowserSignals) return window.KPBrowserSignals.webgl().software;
      var c = document.createElement('canvas');
      var gl = c.getContext('webgl') || c.getContext('experimental-webgl');
      if (gl) {
        var dbg = gl.getExtension('WEBGL_debug_renderer_info');
        if (dbg) {
          var r = String(gl.getParameter(dbg.UNMASKED_RENDERER_WEBGL) || '');
          if (/swiftshader|llvmpipe|mesa offscreen/i.test(r)) return true;
        }
      }
    } catch (e) { /* a browser too old for these checks is not a bot */ }
    return false;
  }

  /* No 'scroll' (15 Oct 2026): window.scrollTo() fires a trusted scroll and the
     proxy fleet used it. A person's scroll starts with touchstart, wheel,
     mousedown (scrollbar) or keydown, all still listed. */
  var EVENTS = ['pointerdown', 'mousedown', 'touchstart', 'keydown', 'wheel'];
  var humanSeen = false;
  function startIfEligible() {
    if (loaded || !humanSeen || !measurementAllowed()) return;
    if (looksAutomated()) return;   /* never load fbevents for automation */
    if (!marketingAllowed()) return; /* keep listening; consent may arrive later */
    EVENTS.forEach(function (n) { window.removeEventListener(n, release, true); });
    ensureFbq();
    fireForPage();
  }
  function release(ev) {
    if (loaded || !ev || !ev.isTrusted) return;
    humanSeen = true;
    startIfEligible();
  }
  EVENTS.forEach(function (n) { window.addEventListener(n, release, true); });
  function consentChanged() {
    startIfEligible();
  }
  document.addEventListener('visitorConsentCollected', consentChanged);
  window.addEventListener('visitorConsentCollected', consentChanged);
  if (window.kpTrackingPolicy) window.kpTrackingPolicy.whenReady(function (allowed) {
    if (allowed) startIfEligible();
  });
})();
